import React from 'react';

export default ({ show, style = {} }) => (
  show ? 
  <div className='nux-focus-background' style={style}/>
    : null
);